import React from "react";
import { CheckCircle2 } from "lucide-react";
import VideoLesson from "./VideoLesson";
import TextLesson from "./TextLesson";
import QuizLesson from "./QuizLesson";
import LiveLesson from "./LiveLesson";

export default function LessonViewer({ lesson, onCompleted }) {
  return (
    <div className="p-6 bg-[#111827] border border-gray-800 rounded-xl" data-testid="lesson-viewer">
      <div className="flex items-start justify-between flex-wrap gap-2 mb-4">
        <div>
          <p className="text-[10px] uppercase tracking-widest text-[#93C5FD]">{lesson.type} · {lesson.duration_min} min</p>
          <h2 className="text-xl font-bold text-white font-display">{lesson.title}</h2>
        </div>
        {lesson.status === "completed" && (
          <span className="inline-flex items-center gap-1 text-xs text-emerald-300 bg-emerald-500/10 border border-emerald-500/30 rounded px-2 py-1">
            <CheckCircle2 className="w-3 h-3" aria-hidden="true" /> Completada
          </span>
        )}
      </div>

      {lesson.type === "video" && <VideoLesson lesson={lesson} onCompleted={onCompleted} />}
      {lesson.type === "text" && <TextLesson lesson={lesson} onCompleted={onCompleted} />}
      {lesson.type === "quiz" && <QuizLesson lesson={lesson} onCompleted={onCompleted} />}
      {lesson.type === "live" && <LiveLesson lesson={lesson} onCompleted={onCompleted} />}
    </div>
  );
}
